export function Config() {
  this.apiUrl = "https://gv3zj9abxc.execute-api.eu-west-1.amazonaws.com/";
}

